import { StoreProvider } from './providers/StoreProvider'
import { AntdProvider } from './providers/AntdProvider'
import { AppRouter } from './providers/AppRouter'
import { GlobalStyles } from './styles/GlobalStyles'
import { ThemeProvider } from 'styled-components'
import { theme } from './styles/theme'
import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
    },
  },
})

function App() {
  useEffect(() => {
    document.documentElement.setAttribute('translate', 'no')
    document.documentElement.lang = 'ru'

    const metaGoogle = document.createElement('meta')
    metaGoogle.name = 'google'
    metaGoogle.content = 'notranslate'
    document.head.appendChild(metaGoogle)
  }, [])
  return (
    <QueryClientProvider client={queryClient}>
      <StoreProvider>
        <ThemeProvider theme={theme}>
          <AntdProvider>
            <GlobalStyles />
            <AppRouter />
          </AntdProvider>
        </ThemeProvider>
      </StoreProvider>
    </QueryClientProvider>
  )
}

export default App
